// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Poppins_6bee3b', '__Poppins_Fallback_6bee3b'","fontStyle":"normal"},"className":"__className_6bee3b","variable":"__variable_6bee3b"};